import { isAuthFailure } from '@/pure/authFailure';
import { isNavigationFailure } from 'vue-router';

export default {
	/**
	 * On a definite auth failure (401) clear the stored token and user and send the user
	 * to /login_redirect, coming back to the current page after login.
	 * Returns true if the session was ended. Network errors keep the session.
	 */
	async endSessionIfAuthFailed({ commit, dispatch }, err) {
		if (!isAuthFailure(err)) return false;
		dispatch('zeroOutTables');
		// eslint-disable-next-line no-undef
		const current = router.currentRoute;
		if (current.path === '/login_redirect') return true;
		commit('setValue', { storeKey: 'returnTo', storeValue: current });
		// Forced logout: ignore all navigation failures, including cancelled ones (see PR #410).
		// eslint-disable-next-line no-undef
		await router.push('/login_redirect').catch((e) => {
			if (!isNavigationFailure(e)) throw e;
		});
		return true;
	}
};
